import { render, staticRenderFns } from "./PhotographyCollaboratorsSection.vue?vue&type=template&id=b7a27856"
import script from "./PhotographyCollaboratorsSection.vue?vue&type=script&lang=ts"
export * from "./PhotographyCollaboratorsSection.vue?vue&type=script&lang=ts"
import style0 from "./PhotographyCollaboratorsSection.vue?vue&type=style&index=0&id=b7a27856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports